import { formatNumber } from '@uikit/helpers/formatNumber';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import Icon from '../Icon/Icon';
import styles from './EnergyGuzzlersQuizSuccess.module.scss';
import type { EnergyGuzzlersQuizSuccessProps } from './types';

const EnergyGuzzlersQuizSuccessBgLottie = dynamic(
  () => import('./EnergyGuzzlersQuizSuccessBgLottie'),
  {
    ssr: false,
  }
);

const EnergyGuzzlersQuizSuccess = ({
  savingsAmount,
}: EnergyGuzzlersQuizSuccessProps) => {
  const formattedSavingsAmountKWh = `${formatNumber(savingsAmount)} kWh`;
  const formattedSavingsAmountCO2 = (
    <span>
      {formatNumber(savingsAmount * 0.0004340131973605, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
      })}{' '}
      t CO<sub>2</sub>
    </span>
  );
  const formattedSavingsAmountTrees = formatNumber(
    savingsAmount * 0.0275944811037792
  );

  return (
    <div className={styles.base}>
      <EnergyGuzzlersQuizSuccessBgLottie
        className={clsx(styles.lottie, styles.left)}
        position="left"
      />
      <EnergyGuzzlersQuizSuccessBgLottie
        className={clsx(styles.lottie, styles.right)}
        position="right"
      />

      <h3 className={styles.headline}>
        Perfekt! 👌 Du hast alle Energiefresser beseitigt!
      </h3>
      <p className={styles.description}>Das hast du gespart:</p>
      <div className={styles.savings}>
        <div className={clsx(styles.saving, styles.savingKwh)}>
          <Icon size="iconSize32" variant="user/lightning" isOutlined />
          <span>{formattedSavingsAmountKWh}</span>
        </div>
        <div className={clsx(styles.saving, styles.savingCo2)}>
          <Icon size="iconSize32" variant="user/plant-leaf" isOutlined />
          {formattedSavingsAmountCO2}
        </div>
      </div>
      <p className={clsx(styles.description, styles.treeHint)}>
        Das entspricht der Menge CO<sub>2</sub>, die{' '}
        {formattedSavingsAmountTrees} Bäume umwandeln können
      </p>
    </div>
  );
};

export default EnergyGuzzlersQuizSuccess;
